import App from './App2.vue';

Vue.config.productionTip = false;

new Vue(
    {
    el: "#app2",
    render: h => h(App),
}
);